// src/components/ConditionalAccessSelector.tsx
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
  Text,
} from '@tonic-one/react';
import { ConditionalAccessSelectorProps } from '@Types/globalSetting';
import { useState } from 'react';
import { useConditionalAccess } from './ConditionalAccessContext';

export const ConditionalAccessSelector = ({
  userName, // userPrincipalName
  userPrincipalName,
  currentPolicyId,
  currentPolicyValue,
  mipEnabled,
  dataSource,
  onPolicyChange,
}: ConditionalAccessSelectorProps) => {
  const { updateUserPolicy, conditionalAccessOptions } = useConditionalAccess();
  const [isUpdating, setIsUpdating] = useState(false);

  const handlePolicyChange = async (newValue: string) => {
    if (newValue === currentPolicyValue || isUpdating) return;

    setIsUpdating(true);
    try {
      await updateUserPolicy(
        {
          userId: '', // Assuming userId is not needed for this operation
          userName,
          userPrincipalName,
        },
        currentPolicyValue,
        newValue,
        currentPolicyId
      );
      onPolicyChange?.(currentPolicyValue, newValue);
    } catch (error) {
      console.error('Failed to update policy:', error);
    } finally {
      setIsUpdating(false);
    }
  };
  const getCurrentPolicyLabel = () => {
    if (!mipEnabled || !dataSource.mip) {
      const noneOption = conditionalAccessOptions.find(
        (option) => option.value === ''
      );
      return noneOption?.label || 'None';
    }

    const currentOption = conditionalAccessOptions.find(
      (option) => option.value === currentPolicyValue
    );

    if (!currentOption?.label) {
      const noneOption = conditionalAccessOptions.find(
        (option) => option.value === ''
      );
      return noneOption?.label || 'None';
    }

    return currentOption.label;
  };

  return (
    <Menu placement="bottom-end">
      <MenuButton
        variant="secondary"
        disabled={isUpdating || !mipEnabled || !dataSource.mip}
        width={280}
      >
        <Text>{getCurrentPolicyLabel()}</Text>
      </MenuButton>
      <Portal>
        <MenuList
          width={280}
          overflow="auto"
          sx={{
            zIndex: 9999,
          }}
        >
          {conditionalAccessOptions.map((option) => (
            <MenuItem
              width={280}
              key={option.value}
              value={option.value}
              onClick={(e: any) => {
                const newValue = e.currentTarget.getAttribute('value');
                if (newValue !== currentPolicyValue) {
                  handlePolicyChange(newValue);
                }
              }}
            >
              <Text>{option.label}</Text>
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};
